import { useQuery } from "@tanstack/react-query";

import {
  CapabilityMapParams,
  getCapabilityMap,
} from "../../services/productPlaneApi";
import { queryKeys } from "./keys";

const STALE_TIME = 60 * 1000;
const GC_TIME = 5 * 60 * 1000;

/**
 * TanStack Query hook for the capability map of a selection of products.
 *
 * The caller builds the request. The response also carries the evidence
 * block (n, articles, single-source share, graph version and date) that the
 * page's scope bar states for the selection.
 */
export function useCapabilityMap(params: CapabilityMapParams, enabled = true) {
  return useQuery({
    queryKey: queryKeys.productPlane.capabilityMap(params),
    queryFn: () => getCapabilityMap(params),
    enabled,
    staleTime: STALE_TIME,
    gcTime: GC_TIME,
  });
}
